import { AsyncContainerModule } from "inversify";
import { AntecipaSlackDi, IAntecipaSlackHandler } from "../types";
import AntecipaSlackHandler from "../AntecipaSlackHandler";
import {
  IMessageBuilderSlackStrategy,
  MessageBuilderSlackDi
} from "../strategies/IMessageBuilderStrategy";
import SlackMessageBuilderStrategy from "../strategies/SlackMessageBuilderStrategy";

export const AntecipaSlackContainer = new AsyncContainerModule(async (bind) => {
  bind<IAntecipaSlackHandler>(AntecipaSlackDi)
    .to(AntecipaSlackHandler)
    .inSingletonScope();
  bind<IMessageBuilderSlackStrategy>(MessageBuilderSlackDi)
    .to(SlackMessageBuilderStrategy)
    .inSingletonScope();
});
